import { render, staticRenderFns } from "./o-notification-modal.vue?vue&type=template&id=baba0c48&"
import script from "./o-notification-modal.vue?vue&type=script&lang=js&"
export * from "./o-notification-modal.vue?vue&type=script&lang=js&"
import style0 from "./o-notification-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports